export const ru = {
  showMore: 'Показать ещё',
};
